/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from './sizes';
/**
 * A download icon.
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 */
export default function ReportsIcon({ className, size = 'small' }) {
    // Use a higher resolution icon for medium+ sizes
    if (['medium', 'mediumLarge', 'large', 'xlarge'].includes(size))
        return (jsx("svg", { xmlns: "http://www.w3.org/2000/svg", sx: {
                width: sizes[size],
                height: sizes[size],
                verticalAlign: 'middle',
            }, className: className, viewBox: "0 0 40 40" },
            jsx("g", { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
                jsx("g", { transform: "translate(7 4)" },
                    jsx("path", { fill: "#D7E6F6", d: "M5.18918919 15.2432432L7.7027027 15.2432432 7.7027027 19.4324324 5.18918919 19.4324324z" }),
                    jsx("path", { fill: "#D7E6F6", d: "M9.37837838 15.2432432L19.4283786 15.2432432 19.4283786 19.4324324 9.37837838 19.4324324z" }),
                    jsx("path", { fill: "#0073E6", fillRule: "nonzero", d: "M2 29h21V2H8.195L2 7.719V29zM1.16 7.133l6.5-6A.5.5 0 018 1h15.5a.5.5 0 01.5.5v28a.5.5 0 01-.5.5h-22a.5.5 0 01-.5-.5v-22a.5.5 0 01.16-.367z" }),
                    jsx("path", { fill: "#0073E6", fillRule: "nonzero", d: "M4.5 32L4.5 33 27 33 27 4.5 26 4.5 26 32z" }),
                    jsx("path", { fill: "#0073E6", fillRule: "nonzero", d: "M1.419 7.622a.5.5 0 100 1h6.703a.5.5 0 00.5-.5V1.419a.5.5 0 10-1 0v6.203H1.419z" }),
                    jsx("path", { fill: "#D7E6F6", d: "M5.18918919 21.2942943L7.7027027 21.2942943 7.7027027 25.4834835 5.18918919 25.4834835z" }),
                    jsx("path", { fill: "#D7E6F6", d: "M9.37837838 21.2942943L19.4283786 21.2942943 19.4283786 25.4834835 9.37837838 25.4834835z" })))));
    return (jsx("svg", { xmlns: "http://www.w3.org/2000/svg", 
        // @ts-ignore
        sx: {
            width: sizes[size],
            height: sizes[size],
            verticalAlign: 'middle',
        }, className: className, viewBox: "0 0 20 20", fill: "none" },
        jsx("path", { fill: "currentColor", d: "M4 5.45L7.417 2h6.586c-.004 0-.005 4.666-.003 14H4.002L4 5.45zM15 2c0-.552-.453-1-.997-1H7L3 5.039V16c0 .552.456.999 1.002.999h9.996A.999.999 0 0015 16V2zm-3 8V9H6v1h6zm0 2v-1H6v1h6zm4-6v12H6v1h10.5a.5.5 0 00.5-.5V6h-1zM7 1.5V5H3.519v1H7.5a.5.5 0 00.5-.5v-4H7z" })));
}
//# sourceMappingURL=ReportsIcon.js.map